<template>
  <div>
    <base-availability
      :name="targetItem.type !== 'category' ? 'do produto' : 'da categoria'"
      :availability="targetItem.availability"
      @updateAvailability="updateAvailability"
    ></base-availability>

    <base-card>
      <base-question text="Opções da loja online" class="mb_25" />

      <base-checkbox
        v-if="targetItem.type !== 'category'"
        v-model="highlightItem"
        :checked="highlightItem"
        class="mb_10"
      >
        <p class="checkbox-area">Destacar este produto na loja</p>
      </base-checkbox>
      <base-checkbox v-model="hideItem" :checked="hideItem">
        <p v-if="targetItem.type === 'category'" class="checkbox-area">
          Ocultar esta categoria na loja
        </p>
        <p v-else class="checkbox-area">Ocultar este produto na loja</p>
      </base-checkbox>
    </base-card>
  </div>
</template>

<script>
import BaseCard from "@/components/Card";
import BaseQuestion from "@/components/Question";
import BaseRadio from "@/components/Radio";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
import BaseCheckbox from "@/components/Checkbox";
import BaseLabel from "@/components/Label";
import BaseAvailability from "@/containers/Availability";
// libs
import Vue from "vue";

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseRadio,
    BaseInput,
    BaseButton,
    BaseCheckbox,
    BaseLabel,
    BaseAvailability,
  },
  data() {
    return {
      hideItem: false,
      highlightItem: false,
    };
  },
  props: {
    targetItem: { default: {} },
  },
  mounted() {
    this.highlightItem = this.targetItem.highlight;
    this.hideItem = !this.targetItem.show;
  },
  methods: {
    updateAvailability(newAvailability) {
      Vue.set(this.targetItem, "availability", newAvailability);
    },
  },
  watch: {
    hideItem(newValue) {
      this.targetItem.show = !newValue;
    },
    highlightItem(newValue) {
      this.targetItem.highlight = newValue;
    }
  }
};
</script>

<style scoped>
.checkbox-area {
  color: #999999;
  font-size: 12px;
}
</style>